import EntityTypeEnum from 'common/enums/entityTypeEnum'
import CustomLoginInterface from 'common/types/entities/CustomLoginInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createNewCustomLogin(
  parentId: string,
  masterBlockId?: MasterBlockId,
): CustomLoginInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.CustomLogin,
    parentId,
    masterBlockId,
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 5,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.CustomLogin),
    childIds: [],
  }
}
